/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectTimeUpdateCommand } from '../../models/create-project-time-update-command';
import { CreateProjectTimeUpdateCommandResult } from '../../models/create-project-time-update-command-result';

export interface ApiProjectTimeUpdateCreateProjectTimeUpdatePost$Params {
      body?: CreateProjectTimeUpdateCommand
}

export function apiProjectTimeUpdateCreateProjectTimeUpdatePost(http: HttpClient, rootUrl: string, params?: ApiProjectTimeUpdateCreateProjectTimeUpdatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectTimeUpdateCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTimeUpdateCreateProjectTimeUpdatePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectTimeUpdateCommandResult>;
    })
  );
}

apiProjectTimeUpdateCreateProjectTimeUpdatePost.PATH = '/api/ProjectTimeUpdate/CreateProjectTimeUpdate';
